import { en } from './en'
// Define supported languages
export type Language = 'en'
// Default language
export const DEFAULT_LANGUAGE: Language = 'en'
// Translations object
const translations = {
  en,
}
// Simple translation function
export const t = (key: string, language: Language = DEFAULT_LANGUAGE): any => {
  const keys = key.split('.')
  let value: any = translations[language]
  for (const k of keys) {
    if (value === undefined) return key
    value = value[k]
  }
  // Return the value directly if it's not a string
  // This allows arrays and objects to be returned
  if (typeof value === 'string') {
    // Replace {year} with current year
    if (value.includes('{year}')) {
      return value.replace('{year}', new Date().getFullYear().toString())
    }
  }
  return value || key
}
export default translations
